import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-amandeep',
  templateUrl: './amandeep.component.html',
  styleUrls: ['./amandeep.component.scss']
})
export class AmandeepComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getAmandeep();
  }
}
